document.documentElement.classList.remove('no-js');

document.querySelectorAll('[data-product-section]').forEach((section) => {
  const form = section.querySelector('.product-form');
  if (!form) return;

  const image = section.querySelector('.product-main-image');
  const price = section.querySelector('[data-product-price]');
  const variants = section.querySelector('[data-variant-images]');
  const variantId = form.querySelector('[data-variant-id]');
  const addButton = form.querySelector('[data-add-to-cart]');
  const zoomButton = section.querySelector('[data-product-image-zoom]');
  const zoomDialog = section.querySelector('[data-product-zoom-dialog]');
  const zoomImage = section.querySelector('.product-zoom-image');

  if (!variants || !variantId) return;

  if (zoomButton && zoomDialog && zoomImage && image) {
    zoomButton.addEventListener('click', () => {
      zoomImage.src = image.currentSrc || image.src;
      zoomImage.srcset = image.srcset;
      zoomImage.alt = image.alt;
      zoomDialog.showModal();
    });

    zoomDialog.addEventListener('click', (event) => {
      if (event.target === zoomDialog) zoomDialog.close();
    });
  }

  const updateProduct = () => {
    const selectedOptions = Array.from(form.querySelectorAll('.variant-option-input:checked')).map((input) => input.value);
    const variantItems = Array.from(variants.children);
    const variant = variantItems.find((item) => {
      const variantOptions = [item.dataset.optionOne, item.dataset.optionTwo, item.dataset.optionThree].filter(Boolean);
      return variantOptions.length === selectedOptions.length && variantOptions.every((value, index) => value === selectedOptions[index]);
    });

    form.querySelectorAll('.variant-option-input').forEach((input) => {
      const optionPosition = Number(input.dataset.optionPosition) - 1;
      const isAvailable = variantItems.some((item) => {
        if (item.dataset.available !== 'true') return false;

        const variantOptions = [item.dataset.optionOne, item.dataset.optionTwo, item.dataset.optionThree].filter(Boolean);
        return variantOptions.every((value, index) => {
          if (index === optionPosition) return value === input.value;
          return !selectedOptions[index] || value === selectedOptions[index];
        });
      });

      input.disabled = !isAvailable;
    });

    if (!variant) {
      if (addButton) addButton.disabled = true;
      return;
    }

    variantId.value = variant.dataset.variantId;

    if (image && variant.dataset.imageSrc) {
      image.src = variant.dataset.imageSrc;
      image.srcset = variant.dataset.imageSrcset;
      image.alt = variant.dataset.imageAlt;

      if (zoomImage) {
        zoomImage.src = variant.dataset.imageSrc;
        zoomImage.srcset = variant.dataset.imageSrcset;
        zoomImage.alt = variant.dataset.imageAlt;
      }
    }

    if (price) price.textContent = variant.dataset.price;

    if (addButton) {
      const available = variant.dataset.available === 'true';
      addButton.disabled = !available;
      addButton.textContent = available ? addButton.dataset.addLabel : addButton.dataset.soldOutLabel;
    }
  };

  form.addEventListener('change', updateProduct);
  updateProduct();
});
